const NotFound = () =>{
    return(<><div id="pageNotFound">PAGE NOT FOUND ( 404 )</div></>)
}

export default NotFound;